export default "__VITE_ASSET__ba610958__"